/*
 * Abstract trade-routes map: dashed brass corridors radiating from
 * Guangzhou across a faint lat/long graticule. Decorative.
 */
export default function RouteMap({ labels, className = "" }) {
    const node = (x, y) => <circle cx={x} cy={y} r="3.5" fill="#F3E3A1" />;
    return (
        <svg
            viewBox="0 0 640 460"
            fill="none"
            className={className}
            role="img"
            aria-label="Trade routes radiating from Guangzhou"
        >
            {/* graticule */}
            <g stroke="#1A425A" strokeWidth="1" opacity="0.55">
                <path d="M0 115 Q320 72 640 115" />
                <path d="M0 230 Q320 187 640 230" />
                <path d="M0 345 Q320 302 640 345" />
                <path d="M160 0 Q138 230 160 460" />
                <path d="M320 0 Q308 230 320 460" />
                <path d="M480 0 Q502 230 480 460" />
            </g>

            {/* corridors from KL */}
            <g stroke="#D4AF37" strokeWidth="1.5" opacity="0.6">
                <path d="M470 320 Q350 130 252 172" className="route-dash" />
                <path d="M470 320 Q280 60 112 92" className="route-dash" />
                <path d="M470 320 Q438 170 402 72" className="route-dash" />
                <path d="M470 320 Q562 230 560 152" className="route-dash" />
            </g>

            {/* destination nodes */}
            {node(252, 172)}
            {node(112, 92)}
            {node(402, 72)}
            {node(560, 152)}

            {/* Guangzhou hub */}
            <circle cx="470" cy="320" r="11" fill="none" stroke="#D4AF37" strokeWidth="1.2" className="pulse-node" />
            <circle cx="470" cy="320" r="5.5" fill="#D4AF37" />

            {/* labels */}
            <g
                fill="#64748B"
                fontSize="10"
                fontFamily="JetBrains Mono, monospace"
                letterSpacing="2"
            >
                <text x="240" y="196" textAnchor="middle">{labels[1]}</text>
                <text x="100" y="116" textAnchor="middle">{labels[0]}</text>
                <text x="404" y="56" textAnchor="middle">{labels[2]}</text>
                <text x="560" y="136" textAnchor="middle">{labels[3]}</text>
                <text x="470" y="345" textAnchor="middle" fill="#D4AF37">GUANGZHOU</text>
            </g>
        </svg>
    );
}
